import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

import type { InParkingCardDetail } from 'src/features/cards/types/card';

const RESOURCE = '/parkings/:parkingId/cards/in-parking/:cardId/exit/';

type ExitInParkingCardFnType = typeof exitInParkingCard;

type ExitInParkingCardDTO = {
    parkingId: string;
    cardId: number;
    open_point: boolean;
    exit_point_id: string;
};

const exitInParkingCard = ({ parkingId, cardId, ...data }: ExitInParkingCardDTO): Promise<InParkingCardDetail> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId, cardId }), data);
};

interface UseExitInParkingCardOptions extends MutationConfig<ExitInParkingCardFnType, GeneralSmartParkError> {}

const useExitInParkingCard = (options: UseExitInParkingCardOptions = {}) =>
    useMutation({
        mutationFn: exitInParkingCard,
        ...options,
    });

export { useExitInParkingCard, exitInParkingCard, type ExitInParkingCardDTO, RESOURCE };
